import { render, staticRenderFns } from "./TreeModal.vue?vue&type=template&id=3d49ed7b&scoped=true&"
import script from "./TreeModal.vue?vue&type=script&lang=js&"
export * from "./TreeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d49ed7b",
  null
  
)

export default component.exports